module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column all-centered prest-declaracao-container"
  }, [_vm._m(0), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "overlay-loading"
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })]) : _vm._e(), _vm._v(" "), _vm._l((_vm.declaracoes), function(item) {
    return (!item.declaracao.includes('AVISO DE CONCLUSÃO') || (item.declaracao.includes('AVISO DE CONCLUSÃO') && _vm.ehUltimaParcela)) ? _c('div', {
      staticClass: "column all-start prest-item-declaracao",
      class: item.aceito == 'S' ? (item.declaracao.includes('AVISO DE CONCLUSÃO') ? 'prest-aceito-conclusao' : 'prest-aceito') : (item.declaracao.includes('AVISO DE CONCLUSÃO') ? 'prest-neutro-conclusao' : 'prest-neutro')
    }, [_c('div', {
      staticClass: "row-flex all-start prest-declaracao"
    }, [(_vm.usuarioLogado.userType === 'ENTIDADE' && _vm.chiefActive()) ? _c('i', {
      staticClass: "fa",
      class: item.aceito == 'S' ? 'fa-check-square-o' : 'fa-square-o',
      attrs: {
        "aria-hidden": "true"
      },
      on: {
        "click": function($event) {
          return _vm.aceitarDeclaracao(item)
        }
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      domProps: {
        "innerHTML": _vm._s(item.declaracao)
      }
    })]), _vm._v(" "), (item.usuario && item.aceito == 'S') ? _c('div', {
      staticClass: "row-flex all-start prest-declaracao-usuario"
    }, [_c('span', {
      staticClass: "prest-declaracao-usuario"
    }, [_c('i', {
      staticClass: "fa fa-user",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v("\n          Aceito por: \n          "), _c('b', [_vm._v(_vm._s(item.usuario) + " " + _vm._s(_vm._f("moment")(item.updated_at, 'DD/MM/YYYY HH:mm')))])])]) : _vm._e(), _vm._v(" "), (item.aceito == 'N') ? _c('div', {
      staticClass: "row-flex all-start prest-declaracao-usuario"
    }, [_vm._m(1, true)]) : _vm._e()]) : _vm._e()
  })], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row-flex all-start w-100"
  }, [_c('h3', {
    staticClass: "prest-box-title row-flex centered-start"
  }, [_vm._v("\n      Declarações\n      "), _c('i', {
    staticClass: "fa fa-check",
    attrs: {
      "aria-hidden": "true"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "prest-declaracao-usuario row-flex all-centered"
  }, [_c('i', {
    staticClass: "fa fa-exclamation",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('b', [_vm._v("Pendente de adesão para parcela de adiantamento. (representante legal)")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-a5ca17fa!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/prestacaoContasSimplificado/PrestacaoDeclaracoes.vue
// module id = 2048
// module chunks = 1